import { render, staticRenderFns } from "./real-monitor.vue?vue&type=template&id=7f07903e&"
import script from "./real-monitor.vue?vue&type=script&lang=js&"
export * from "./real-monitor.vue?vue&type=script&lang=js&"
import style0 from "./real-monitor.vue?vue&type=style&index=0&id=7f07903e&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports